import AppContext from "@common/contexts/App";
import Preloader from "@common/controls/Preloader/component";
import classNames from "classnames";
import * as React from "react";
import { type BodyProps } from "../Body/component";

export interface ContentChildren {
  header: React.ReactNode;
  body: React.ReactElement<BodyProps>;
  footer?: React.ReactNode;
}

interface ContentProps {
  isLoading?: boolean;
  loadingText?: string;
  height?: string | number;
  maxHeight?: string | number;
  ref?: React.RefObject<HTMLDivElement | null>;
  shouldRenderWhileLoading: boolean;
  children: ContentChildren;
}

export default (props: ContentProps) => {
  const appContext = React.useContext(AppContext);

  return (
    <div
      ref={props.ref}
      className={classNames("modal-content", {
        headerless: !props.children.header
      })}
      style={{ height: props.height, maxHeight: props.maxHeight }}
    >
      {props.children.header}

      {props.isLoading ? (
        <div className="modal-body" style={{ maxHeight: props.children.body?.props?.maxHeight }}>
          <Preloader
            loadingText={props.loadingText}
            relative
            type={appContext.context === "admin" ? "bars" : "spinner"}
          />

          {props.shouldRenderWhileLoading ? <div style={{ display: "none" }}>{props.children.body}</div> : null}
        </div>
      ) : (
        <>
          {props.children.body}
          {props.children.footer}
        </>
      )}
    </div>
  );
};
